// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bGqAsyvP4mq6IOhrPD2Q {
  height: 100%;
}
.bGqAsyvP4mq6IOhrPD2Q .ant-list {
  overflow: hidden;
}
.bGqAsyvP4mq6IOhrPD2Q .ant-list .ant-list-header {
  background: #f7f8f9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Explore/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;AAAF;AADA;EAKM,gBAAA;AADN;AAJA;EAOQ,mBAAA;AAAR","sourcesContent":["\n.container {\n  height: 100%;\n\n  :global {\n    .ant-list {\n      overflow: hidden;\n      .ant-list-header {\n        background: #f7f8f9;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `bGqAsyvP4mq6IOhrPD2Q`
};
export default ___CSS_LOADER_EXPORT___;
